/**
 * @desc 导出付款单
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = any;
export function request(
  params: API.tms.paymentMaster.exportPayRequestReport.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/paymentMaster/exportPayRequestReport`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
